var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCar = function SvgCar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELEMENT|ICON|Vehicle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.04053 5.42456H17.6035",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5281 0.78125V5.42473",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.67174 12.0582C5.83018 12.0582 6.76927 11.1673 6.76927 10.0682C6.76927 8.96911 5.83018 8.07812 4.67174 8.07812C3.51331 8.07812 2.57422 8.96911 2.57422 10.0682C2.57422 11.1673 3.51331 12.0582 4.67174 12.0582Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.0619 12.0582C14.2203 12.0582 15.1594 11.1673 15.1594 10.0682C15.1594 8.96911 14.2203 8.07812 13.0619 8.07812C11.9034 8.07812 10.9644 8.96911 10.9644 10.0682C10.9644 11.1673 11.9034 12.0582 13.0619 12.0582Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.739 1.88109C15.3838 1.20712 14.6573 0.78125 13.8631 0.78125H2.43888C1.66629 0.78125 1.04053 1.37495 1.04053 2.10796V9.40485C1.04053 9.77102 1.35376 10.0682 1.7397 10.0682H2.5742C2.5742 8.96903 3.51319 8.07814 4.67173 8.07814C5.83026 8.07814 6.76925 8.96903 6.76925 10.0682H10.9643C10.9643 8.96903 11.9033 8.07814 13.0618 8.07814C14.2204 8.07814 15.1594 8.96903 15.1594 10.0682H17.2569C17.6428 10.0682 17.9561 9.77102 17.9561 9.40485V6.08808L15.739 1.88109Z",
    stroke: "#2E3744",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "car.fd438660f9fc79f95c6f4d23141d52ef.svg";